import { Flex } from 'components/shared/flex'
import { A4 } from 'components/shared/print'
import { ProductItem } from 'entities/product_item'
import { Result } from 'entities/result'
import { Sample } from 'entities/sample'
import { InstitutionViewModel } from 'view_models/institution_view_model'
import { PatientViewModel } from 'view_models/patient_view_model'
import { ResultViewModel } from 'view_models/result_view_model'
import { SampleViewModel } from 'view_models/sample_view_model'

import Logo from 'components/../../public/logo_h.png'
import Arrow from 'api/../../public/arrow.png'
import LungResult from 'api/../../public/lung.jpg'
import LungMainResult from 'api/../../public/lung_main.jpg'
import LungQcResult from 'api/../../public/lung_qc.jpg'
import LungRiskMarkerResult from 'api/../../public/lung_risk.jpg'
import OvaryResult from 'api/../../public/ovary.jpg'
import OvaryMainResult from 'api/../../public/ovary_main.jpg'
import OvaryQcResult from 'api/../../public/ovary_qc.jpg'
import OvaryRiskMarkerResult from 'api/../../public/ovary_risk.jpg'
import OvaryNetwork from 'api/../../public/ovary_network.png'
import OvaryIncBar from 'api/../../public/ovary_inc_bar.png'
import OvaryDescBar from 'api/../../public/ovary_desc_bar.png'
import OvaryDist from 'api/../../public/ovary_dist.png'
import NgLungResult from 'api/../../public/lung_ng.jpg'
import NgOvaryResult from 'api/../../public/ovary_ng.jpg'

const ngResultImages: { [key: string]: string } = {
    lung: NgLungResult,
    ovary: NgOvaryResult,
}

const resultImages: { [key: string]: string } = {
    lung: LungResult,
    lungMain: LungMainResult,
    lungRiskMarker: LungRiskMarkerResult,
    lungQc: LungQcResult,
    ovary: OvaryResult,
    ovaryMain: OvaryMainResult,
    ovaryRiskMarker: OvaryRiskMarkerResult,
    ovaryQc: OvaryQcResult,
    ovaryNetwork: OvaryNetwork,
    ovaryIncBar: OvaryIncBar,
    ovaryDescBar: OvaryDescBar,
    ovaryDist: OvaryDist,
    arrow: Arrow,
}

const productItemColor: { [key: string]: string } = {
    ovary: '#de508c',
    lung: '#5490C1',
}

type ResultGuidancePaperProps = {
    sample: Sample
}

export const ResultGuidancePaper = (props: ResultGuidancePaperProps) => {
    const { sample } = props
    const vm = new SampleViewModel(sample)
    const instVm = new InstitutionViewModel(sample.institution!)
    const patientVm = new PatientViewModel(sample.patient!)
    return (
        <A4 padding={0} landscape={false}>
            <div style={{ height: '6mm', width: '1mm' }}></div>
            <Flex style={{ padding: 55, borderBottom: 'solid 1px black' }} justifyContent="space-between">
                <div style={{ padding: 10, width: 300, height: 155, position: 'relative', fontSize: 14 }}>
                    <div>〒{instVm.addressVm().zipCode()}</div>
                    <div>{instVm.addressVm().whole({ showZipCode: false })}</div>
                    <div style={{ marginBottom: 30 }}>{instVm.object.name} 御中</div>
                </div>
                <div style={{ textAlign: 'right', position: 'relative' }}>
                    <img src={Logo} style={{ width: 230, objectFit: 'contain', position: 'absolute', top: -20, right: -20 }}></img>
                    <div style={{ textAlign: 'right', marginTop: 60 }}>
                        <div>〒464-0814 愛知県名古屋市千種区不老町1</div>
                        <div>NIC711・712号</div>
                        <div>Craif株式会社 中部検査センター</div>
                        <div>TEL: 070-3149-6278</div>
                    </div>
                </div>
            </Flex>
            <div style={{ padding: 45 }}>
                <div style={{ width: '100%', textAlign: 'center', fontSize: 21, fontWeight: 'bold', marginBottom: 40 }}>
                    <div>結果票送付のご案内</div>
                </div>
                <div style={{ marginBottom: 30 }}>
                    <div>拝啓 時下ますますご清栄のこととお慶び申し上げます。</div>
                    <div>
                        この度はmiSignal™をご利用くださいまして誠にありがとうございました。下記の通り患者様への検査結果票・ご案内と、医療機関様向けのご説明書をお送りいたしますので、患者様へのお渡し及びご説明のほど何卒宜しくお願いいたします。
                    </div>
                    <div style={{ textAlign: 'right' }}>敬具</div>
                </div>
                <div style={{ textAlign: 'center' }}>記</div>
                <div style={{ marginBottom: 40 }}>
                    {sample.productItems?.map((productItem) => (
                        <div key={`souhujo-result-${sample.id}-${productItem.id}`} style={{ marginTop: 30 }}>
                            <div>
                                患者様： ({sample.code}) - ({productItem.name?.replaceAll('がん', '')}) {patientVm.fullName()} 様
                            </div>
                            <table style={{ marginTop: 20 }}>
                                <tbody>
                                    <tr>
                                        <td style={{ width: 600 }}>
                                            <div>・miSignal™（{productItem.name}）結果票</div>
                                            <div>(1通は医療機関様控えとして保管ください)</div>
                                        </td>
                                        <td>2 通</td>
                                    </tr>
                                    <tr>
                                        <td>・miSignal™をご利用のお客様へ（{productItem.name}）</td>
                                        <td>1 通</td>
                                    </tr>
                                    <tr>
                                        <td>・（医療機関様向け）miSignal™（{productItem.name}）検査のご説明*</td>
                                        <td>1 通</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style={{ marginTop: 40 }}>
                                (*)この資料は医療機関様向けです。患者様への説明資料ではございませんのでお渡しいただかないようご注意ください。
                                <br />
                                追加検査で他医療機関様をご紹介いただく場合に、紹介状に同封する形でご活用いただけます。
                            </div>
                        </div>
                    ))}
                </div>
                <div style={{ textAlign: 'right' }}>以上</div>
            </div>
        </A4>
    )
}

type NgResultPaperProps = {
    key?: string
    sample: Sample
    productItem: ProductItem
}

export const NgResultPaper = (props: NgResultPaperProps) => {
    const { key, sample, productItem } = props
    const vm = new SampleViewModel(sample)
    const patientVm = new PatientViewModel(sample.patient!)
    return (
        <A4 key={key ?? 'key'} padding={0} landscape={false} style={{ padding: 0 }}>
            <div className={'preview-result'} style={{ width: '100%', height: '100%', position: 'relative' }}>
                <img src={ngResultImages[`${productItem.nameEn!}`]} style={{ objectFit: 'contain', width: '100%' }} />
                <div style={{ position: 'absolute', right: 60, top: 25, fontSize: 10 }}>{sample.code}</div>
                <div style={{ position: 'absolute', right: 150, top: 50, fontSize: 24 }}>{patientVm.fullName()}</div>
                <div className="patient-info" style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}>
                    <div style={{ position: 'absolute', left: 525, top: 103 }}>{patientVm.age()}</div>
                    <div style={{ position: 'absolute', left: 606, top: 103 }}>{patientVm.gender()}</div>
                    <div style={{ position: 'absolute', left: 555, top: 131 }}>{sample.karteNumber}</div>
                    <div style={{ position: 'absolute', left: 678, top: 131 }}>{vm.collectionDateText()}</div>
                    <div style={{ position: 'absolute', left: 560, top: 158 }}>{sample.institution?.name}</div>
                    <div style={{ position: 'absolute', left: 560, top: 187 }}>{sample.institution?.code}</div>
                </div>
                <div style={{ position: 'absolute', left: 90, top: 330, fontSize: 70, fontWeight: 'bold' }}>{'ー'}</div>
                <div style={{ position: 'absolute', left: 220, top: 330, fontWeight: 'bold' }}>
                    <div>今回は以下の理由で検査ができませんでした。</div>
                    {sample.differentContainer && <div>・指定容器以外の容器でのご提出のため</div>}
                    {sample.nonUrine && <div>・尿以外の検体のご提出のため</div>}
                    {sample.quantityStatus === 'NG' && <div>・尿量が1ml以下であったため</div>}
                </div>
                <div style={{ position: 'absolute', top: 580, left: 80, width: 172 }}>
                    <div style={{ fontSize: 35, fontWeight: 'bold', marginBottom: 5, textAlign: 'center' }}>{'N/A'}</div>
                </div>
                <div style={{ position: 'absolute', top: 580, left: 315, width: 165 }}>
                    <div style={{ fontSize: 35, fontWeight: 'bold', marginBottom: 5, textAlign: 'center' }}>{'N/A'}</div>
                </div>
                <div style={{ position: 'absolute', top: 580, left: 550, width: 165 }}>
                    <div style={{ fontSize: 35, fontWeight: 'bold', marginBottom: 5, textAlign: 'center' }}>{'N/A'}</div>
                </div>
            </div>
        </A4>
    )
}

type OkResultPaperProps = {
    key: string
    sample: Sample
    result: Result
}

export const OkResultPaper = (props: OkResultPaperProps) => {
    const { key, sample, result } = props
    const vm = new SampleViewModel(sample)
    const patientVm = new PatientViewModel(sample.patient!)
    const resultVm = new ResultViewModel(result)
    const referenceReasons = vm.getReferenceReason()

    const getRiskLevelPos = (productItem: ProductItem): number | undefined => {
        if (productItem.nameEn === 'lung') {
            return 244
        } else if (productItem.nameEn === 'ovary') {
            return 225
        } else {
            return undefined
        }
    }

    return (
        <A4 key={key ?? 'key'} padding={0} landscape={false} style={{ padding: 0 }}>
            <div className={'preview-result'} style={{ width: '100%', height: '100%', position: 'relative' }}>
                <img src={resultImages[`${result.productItem!.nameEn!}Main`]} style={{ objectFit: 'contain', width: '100%' }} />
                <div style={{ position: 'absolute', right: 60, top: 25, fontSize: 10 }}>{sample.code}</div>
                <div style={{ position: 'absolute', right: 150, top: 50, fontSize: 24 }}>{patientVm.fullName()}</div>
                <div className="patient-info" style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}>
                    <div style={{ position: 'absolute', left: 525, top: 103 }}>{patientVm.age()}</div>
                    <div style={{ position: 'absolute', left: 606, top: 103 }}>{patientVm.gender()}</div>
                    <div style={{ position: 'absolute', left: 555, top: 131 }}>{sample.karteNumber}</div>
                    <div style={{ position: 'absolute', left: 678, top: 131 }}>{vm.collectionDateText()}</div>
                    <div style={{ position: 'absolute', left: 534, bottom: 948, lineHeight: '10px', width: 200 }}>{sample.institution?.name}</div>
                    <div style={{ position: 'absolute', left: 546, top: 187 }}>{sample.institution?.code}</div>
                </div>
                <div style={{ position: 'absolute', left: 100, top: 320, fontSize: 70, fontWeight: 'bold' }}>{resultVm.riskLevel()}</div>
                <div
                    style={{
                        position: 'absolute',
                        right: getRiskLevelPos(result.productItem!),
                        top: 329,
                        fontSize: 15,
                        fontWeight: 'bold',
                    }}
                >
                    {resultVm.riskLevel()}
                </div>
                {sample.resultStatus === 'REFERENCE' && vm.getReferenceReason().length > 0 && (
                    <div style={{ position: 'absolute', top: 425, left: 95, fontSize: 11 }}>
                        ※右記の理由からリスク判定結果は参考値となります： {referenceReasons.join('・')}
                    </div>
                )}

                <div style={{ position: 'absolute', top: 555, left: 80, width: 172 }}>
                    <div style={{ fontSize: 35, fontWeight: 'bold', marginBottom: 5, textAlign: 'center' }}>{resultVm.riskRatio()}</div>
                    <div style={{ fontSize: 11, lineHeight: 1.6 }}>
                        あなたと同じ性別・年代における{result.productItem?.name}
                        へのかかりやすさと、今回の解析結果から、実際にがんと診断される確率を予測した値です。
                    </div>
                </div>
                <div style={{ position: 'absolute', top: 555, left: 315, width: 165 }}>
                    <div style={{ fontSize: 35, fontWeight: 'bold', marginBottom: 5, textAlign: 'center' }}>{resultVm.riskComparison()}</div>
                    <div style={{ fontSize: 11, lineHeight: 1.6 }}>
                        あなたと同じ性別・年代で{result.productItem?.name}にかかっている割合は1万人に
                        {resultVm.numberOfPeople()}
                        です。
                    </div>
                </div>
                <div style={{ position: 'absolute', top: 555, left: 550, width: 165 }}>
                    <div style={{ fontSize: 35, fontWeight: 'bold', marginBottom: 5, textAlign: 'center' }}>{resultVm.riskLevel()}</div>
                    <div style={{ fontSize: 11, lineHeight: 1.6 }}>
                        今回の検査の結果、現時点のがんリスクは「<span>{resultVm.riskLevel()}</span>
                        」と判定されています。
                        {resultVm.riskLevel() === '低' ? (
                            <>今後も定期的に検診を受けましょう</>
                        ) : (
                            <>念のため、医師と相談の上、{resultVm.part()}の状態を病院でチェックしましょう</>
                        )}
                    </div>
                </div>
                <div style={{ width: 640, backgroundColor: '#8888', position: 'absolute', top: 786, left: 73 }}>
                    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
                        {(() => {
                            const i = resultVm.info()
                            if (i && i.score) {
                                const ratio = resultVm.barPointRatio()
                                const value = resultVm.convertViewScore()
                                return (
                                    <div style={{ position: 'absolute', left: 625 * ratio }}>
                                        <div style={{ fontSize: 14, fontWeight: 'bold', marginBottom: 2 }}>{Math.round(value * 10) / 10}</div>
                                        <div className="triangle" style={{ height: 10, width: 10 }}></div>
                                    </div>
                                )
                            }
                        })()}
                    </div>
                </div>
            </div>
        </A4>
    )
}

type RiskMarkerResultPaperProps = {
    key: string
    sample: Sample
    result: Result
}

export const RiskMarkerResultPaper = (props: RiskMarkerResultPaperProps) => {
    const { key, sample, result } = props
    const vm = new SampleViewModel(sample)
    const patientVm = new PatientViewModel(sample.patient!)
    const resultVm = new ResultViewModel(result)
    return (
        <A4 key={key ?? 'key'} padding={0} landscape={false} style={{ padding: 0 }}>
            <div className={'preview-result'} style={{ width: '100%', height: '100%', position: 'relative' }}>
                <img src={resultImages[`${result.productItem!.nameEn!}RiskMarker`]} style={{ objectFit: 'contain', width: '100%' }} />
                <div style={{ position: 'absolute', right: 100, top: 53, fontSize: 12 }}>{patientVm.fullName()}</div>
                <div style={{ position: 'absolute', right: 75, top: 80, fontSize: 12 }}>{sample.karteNumber}</div>
                {/* 冒頭の説明文 */}
                <div style={{ position: 'absolute', left: 55, top: 160, width: 690, fontSize: 11 }}>
                    {result.productItem?.name}
                    に特有のmiRNAの発現量を定量し、発現パターンについての評価を行いました。全てのmiRNAスコアを総合して、人工知能(AI)によるアル
                    ゴリズムに基づき、がんリスクスコアの算出を行いました。
                </div>
                {/* スコア欄を大きく囲う色付きの四角の線 */}
                <div
                    style={{
                        position: 'absolute',
                        border: '1px solid',
                        borderColor: productItemColor[result.productItem?.nameEn ?? ''],
                        left: 255,
                        top: 220,
                        width: 450,
                        height: 45 + 70 * resultVm.riskMarkers().length,
                    }}
                />
                {/* AIっぽいネットワークの画像 */}
                <img
                    src={resultImages[`${result.productItem!.nameEn!}Network`]}
                    style={{ position: 'absolute', left: 430, top: 262 + 70 * resultVm.riskMarkers().length, width: 50, backgroundColor: 'white' }}
                />
                {/* 下のリスクスコアの赤い四角 */}
                <Flex
                    alignItems="center"
                    style={{
                        paddingLeft: 20,
                        position: 'absolute',
                        backgroundColor: productItemColor[result.productItem?.nameEn ?? ''],
                        left: 305,
                        top: 332 + 70 * resultVm.riskMarkers().length,
                        width: 300,
                        height: 50,
                        color: 'white',
                    }}
                >
                    <div>あなたのがんリスクスコア</div>
                    <Flex style={{ backgroundColor: '#fff', width: 50, height: 20, textAlign: 'center' }} alignItems="center">
                        <div style={{ width: '100%', height: '100%', alignItems: 'center', color: 'black', fontSize: 13 }}>
                            {(Math.round(resultVm.convertViewScore() * 10) / 10).toFixed(1)}
                        </div>
                    </Flex>
                </Flex>

                {/* 一番上の黒線  */}
                <div
                    style={{
                        position: 'absolute',
                        borderBottom: '1px solid',
                        borderBottomColor: '#000',
                        left: 75,
                        top: 220,
                        width: 600,
                        height: 30,
                        fontSize: 20,
                        fontWeight: 'bold',
                    }}
                >
                    測定結果
                </div>
                {/* マーカー列の薄い色付き背景の四角 */}
                <div
                    style={{
                        backgroundColor: productItemColor[result.productItem?.nameEn ?? ''] + '25',
                        position: 'absolute',
                        left: 280,
                        top: 225,
                        width: 100,
                        height: 32 + 70 * resultVm.riskMarkers().length,
                        fontSize: 12,
                        textAlign: 'center',
                        paddingTop: 5,
                    }}
                >
                    スコア
                </div>
                {resultVm.riskMarkers().map((item: Record<string, any>, i: number) => {
                    const protocolVersionProbe = result.productItem?.currentProtocolVersion?.protocolVersionProbes?.find((p) => p.probe?.name === item.probe)
                    const minRange = protocolVersionProbe?.ctMinRange ?? 0
                    const maxRange = protocolVersionProbe?.ctMaxRange ?? 0
                    const scoreMax = 4
                    const score: number = ((item.ct - (minRange + maxRange) / 2) / ((maxRange - minRange) / 2)) * scoreMax
                    return (
                        <>
                            {/* 黒線と、miRNAの名前  */}
                            <Flex
                                key={i}
                                style={{
                                    position: 'absolute',
                                    borderBottom: '1px solid',
                                    borderBottomColor: '#000',
                                    left: 75,
                                    top: 250 + 70 * i,
                                    width: 600,
                                    height: 70,
                                    fontSize: 11,
                                }}
                            >
                                <Flex
                                    style={{
                                        alignItems: 'center',
                                        fontWeight: 'bold',
                                        height: '100%',
                                        width: 180,
                                        fontSize: 13,
                                        marginLeft: 10,
                                        marginBottom: 0,
                                    }}
                                >
                                    Cancer-risk miRNA #{i + 1}
                                </Flex>
                                <img
                                    src={resultImages[`${result.productItem!.nameEn!}${protocolVersionProbe?.isNegativeMarker ? 'Desc' : 'Inc'}Bar`]}
                                    style={{ width: 420, marginTop: 25, paddingLeft: 150 }}
                                />
                            </Flex>
                            {/* 白い四角(スコア) */}
                            <Flex
                                key={i}
                                style={{
                                    position: 'absolute',
                                    backgroundColor: '#fff',
                                    left: 305,
                                    top: 275 + 70 * i,
                                    width: 50,
                                    height: 20,
                                    fontSize: 13,
                                    textAlign: 'center',
                                }}
                                alignItems="center"
                            >
                                <div style={{ width: '100%', height: '100%', alignItems: 'center' }}>{(Math.round(score * 10) / 10).toFixed(1)}</div>
                            </Flex>
                            <div style={{ width: 640, backgroundColor: '#8888', position: 'absolute', top: 250 + 70 * i, left: 400 }}>
                                <div style={{ width: '100%', height: '100%', position: 'relative' }}>
                                    {(() => {
                                        if (score) {
                                            const ratio = (score + scoreMax) / (scoreMax * 2)
                                            return (
                                                <div style={{ position: 'absolute', left: 265 * ratio - 3, top: -2 }}>
                                                    <div style={{ fontSize: 14, marginBottom: 0 }}>{(Math.round(score * 10) / 10).toFixed(1)}</div>
                                                    <div className="triangle"></div>
                                                </div>
                                            )
                                        }
                                    })()}
                                </div>
                            </div>
                        </>
                    )
                })}
            </div>
        </A4>
    )
}

type QcResultPaperProps = {
    key: string
    sample: Sample
    result: Result
}

export const QcResultPaper = (props: QcResultPaperProps) => {
    const { key, sample, result } = props
    const vm = new SampleViewModel(sample)
    const patientVm = new PatientViewModel(sample.patient!)
    const resultVm = new ResultViewModel(result)
    const referenceReasons = vm.getReferenceReason()

    const QcResultRow = (marker: Record<string, any>, mirnaName: string, whatNumber: number) => {
        const protocolVersionProbe = result.productItem?.qcVersion?.protocolVersionProbes?.find((p) => p.probe?.name === marker.probe)
        const xlcl = protocolVersionProbe?.xlcl ?? 0
        const xucl = protocolVersionProbe?.xucl ?? 1
        const ratio = Math.min(Math.max((marker.ct - xlcl) / (xucl - xlcl), -0.1), 1.1)

        return (
            <>
                {/* 黒線と、miRNAの名前  */}
                <Flex
                    key={mirnaName}
                    style={{
                        position: 'absolute',
                        borderBottom: '1px solid',
                        borderBottomColor: 'black',
                        left: 75,
                        top: 350 + 100 * whatNumber,
                        width: 600,
                        height: 100,
                        fontSize: 11,
                    }}
                >
                    <Flex style={{ alignItems: 'center', fontWeight: 'bold', height: '100%', width: 180, fontSize: 13, marginLeft: 10, marginBottom: 0 }}>
                        {mirnaName}
                    </Flex>
                    <img src={resultImages[`${result.productItem!.nameEn!}Dist`]} style={{ width: 420, marginTop: 20, paddingLeft: 200 }} />
                </Flex>

                <Flex
                    key={mirnaName}
                    style={{ position: 'absolute', left: 250, top: 375 + 100 * whatNumber, width: 200, height: 20, fontSize: 13, textAlign: 'center' }}
                    alignItems="center"
                    flexDirection="column"
                >
                    {/* 白い四角(スコア) */}
                    <div style={{ width: 50, height: '100%', alignItems: 'center', backgroundColor: 'white' }}>
                        {(Math.round(marker.ct * 10) / 10).toFixed(1)}
                    </div>
                    <Flex style={{ textAlign: 'center', width: '100%', justifyContent: 'center' }} className="">
                        <div>{'(基準値 '}</div>
                        {/* 白い四角(スコア) */}
                        <div style={{ width: 50, alignItems: 'center', backgroundColor: 'white', height: 20, marginLeft: 3 }}>
                            {protocolVersionProbe?.xlcl ?? '--'}
                        </div>
                        <div style={{ marginLeft: 3 }}>~ </div>
                        <div style={{ width: 50, alignItems: 'center', backgroundColor: 'white', height: 20, marginLeft: 3 }}>
                            {protocolVersionProbe?.xucl ?? '--'}
                        </div>
                        <div style={{ marginLeft: 3 }}>)</div>
                    </Flex>
                </Flex>
                {xlcl !== 0 && xucl !== 1 && (
                    <div style={{ width: 640, position: 'absolute', top: 392 + 100 * whatNumber, left: 477 + ratio * 168 }}>
                        <img src={resultImages[`arrow`]} style={{ width: 8 }} />
                    </div>
                )}
            </>
        )
    }

    return (
        <A4 key={key ?? 'key'} padding={0} landscape={false} style={{ padding: 0 }}>
            <div className={'preview-result'} style={{ width: '100%', height: '100%', position: 'relative' }}>
                <img src={resultImages[`${result.productItem!.nameEn!}Qc`]} style={{ objectFit: 'contain', width: '100%' }} />
                <div style={{ position: 'absolute', right: 100, top: 53, fontSize: 12 }}>{patientVm.fullName()}</div>
                <div style={{ position: 'absolute', right: 75, top: 80, fontSize: 12 }}>{sample.karteNumber}</div>

                {/* 一番上の黒線  */}
                <div
                    style={{
                        position: 'absolute',
                        borderBottom: '1px solid',
                        borderBottomColor: '#000',
                        left: 75,
                        top: 320,
                        width: 600,
                        height: 30,
                        fontSize: 20,
                        fontWeight: 'bold',
                    }}
                >
                    測定結果
                </div>
                {/* マーカー列の薄い色付き背景の四角 */}
                <div
                    style={{
                        backgroundColor: productItemColor[result.productItem?.nameEn ?? '' ?? ''] + '25',
                        position: 'absolute',
                        left: 250,
                        top: 325,
                        width: 200,
                        height: 32 + 100 * (resultVm.allMarkers().length - resultVm.riskMarkers().length),
                        fontSize: 12,
                        textAlign: 'center',
                        paddingTop: 5,
                    }}
                >
                    測定値
                </div>
                {resultVm.hkMarkers().map((item: Record<string, any>, i: number) => {
                    return QcResultRow(item, `HK miRNA #${i + 1}`, i)
                })}
                {resultVm.RtSpikeInMarkers().map((item: Record<string, any>, i: number) => {
                    return QcResultRow(item, `HK miRNA #${i + 1}`, i + resultVm.hkMarkers().length)
                })}
                {resultVm.RnaSpikeInMarkers().map((item: Record<string, any>, i: number) => {
                    return QcResultRow(item, `RNA spike-in miRNA #${i + 1}`, i + resultVm.hkMarkers().length + resultVm.RtSpikeInMarkers().length)
                })}
            </div>
        </A4>
    )
}
